<template>
    <v-dialog
        v-model="isDialogOpen"
        hide-overlay
        persistent
        width="300"
    >
        <v-card
            color="orange lighten-2"
            dark
        >
            <v-card-text>
                {{ $t('calculating') }}
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import DialogRemote from "../../mixins/DialogRemote";

export default {
    name: "LoadingDialog",
    mixins: [ DialogRemote ]
}
</script>

<style scoped>

</style>
